import { FC } from 'react';
import { HStack } from '@wegroup/design-system';
import BasketFinishButton from '@flows/src/components/flow-products/quotes/basket/actions/BasketFinishButton';
import useQueryParams from '@common/src/hooks/useQueryParams';

const BottomBarBasketActions: FC = () => {
  const queryParams = useQueryParams();
  const sessionId = queryParams.get('session_id') || '';

  return (
    <HStack spacing="4">
      <BasketFinishButton sessionId={sessionId} />
    </HStack>
  );
};

export default BottomBarBasketActions;
